import React from 'react'
export default class MessageRecordLockedModal extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    
    return (
      <div className={`alert ${this.props.additional_classes ? this.props.additional_classes : ''}`}>
        <h4 style={{ marginTop: '5px', textAlign: 'center' }}><strong><span className="ss-lock"></span>{` ${I18n.t('record_locked')}`}</strong></h4>
        <hr/>
        <p className="text-center">{this.props.message}</p>
      
      </div>
    );
  };
}